import axios from "axios";
import { useLoginStore } from "@/store/auth";
import { storeToRefs } from "pinia";
import useUtil from "@/composables/useUtil";

const appApi = () => {
  const { baseURL } = useUtil();
  const { userStoreToken } = storeToRefs(useLoginStore());

  const instance = axios.create({
    baseURL: baseURL.value,
    headers: {
      Authorization: "Bearer " + userStoreToken.value,
    },
  });

  return instance;
};

export default appApi;
